<template>
  <page>
    <span slot="page-title">About</span>
    <p>The 2018 U.S. Federal Election Modeling contained on this site was developed and is maintained by
      <a href="https://0ptimus.com/team/scott-tranter/">Scott Tranter</a>,
      <a href="https://0ptimus.com/team/jakob-grimmius/">Jakob Grimmius</a>,
      <a href="https://0ptimus.com/team/neha-bora/">Neha Bora</a>
      and <a href="https://0ptimus.com/team/alex-alduncin/">Alex Alduncin</a>
      of the Data Science team at <a href="https://0ptimus.com/">0ptimus</a>.
    </p>
    <p>The model on the website is our public facing version and includes public polling.  0ptimus advises private clients on legislative risk and in those instances a private version of the model is utilized that contains client specific datasets including private polling.</p>
    <p>The data was retrieved from public sources where appropriate and the privately sourced data is derived from 0ptimus’s access to political, economic and demographic data sets at the national, state and district level.</p>
    <p>Think you have a smart angle we’re missing? Just like this stuff in general, want to come work at a cool place? Reach out and tell us.</p>
    <p>If you have any question’s please reach out:</p>
    <p>
      <span>Press: <a href="mailto:press@0ptimus.com">press@0ptimus.com</a></span>
      <br>
      <span>General Inquiries: <a href="mailto:Elections@0ptimus.com">Elections@0ptimus.com</a></span>
      <br>
      <span>Twitter: <a href="https://twitter.com/be0ptimus">@Be0ptimus</a></span>
      <br>
      <span>Twitter: <a href="https://twitter.com/0ptimusPredicts">@0ptimusPredicts</a></span>
    </p>
  </page>
</template>

<script>
import { OptiCard } from '@/components/optimus'
import { Page } from '@/components'

const name = 'about'

const components = {
  OptiCard,
  Page
}

export default {
  name,
  components,
  metaInfo: {
    title: 'About',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'About'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'About'
      }, {
        vmid: 'description',
        name: 'description',
        content: 'The Øptimus forecasting model was created and maintained by Scott Tranter (partner) of Øptimus Consulting and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Øptimus data science team.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: 'The Øptimus forecasting model was created and maintained by Scott Tranter (partner) of Øptimus Consulting and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Øptimus data science team.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: 'The Øptimus forecasting model was created and maintained by Scott Tranter (partner) of Øptimus Consulting and Alex Alduncin, Neha Bora, and Jakob Grimmius of the Øptimus data science team.'
      }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/About.vue